/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnimaticValueItem,
  AnimaticValueItem$inboundSchema,
  AnimaticValueItem$Outbound,
  AnimaticValueItem$outboundSchema,
} from "./animaticvalueitem.js";

/**
 * Specifies details for a value shelf that is shown below an Equipment Browser Item.
 */
export type AnimaticValueShelf = {
  /**
   * The items to display on the shelf
   */
  items: Array<AnimaticValueItem>;
};

/** @internal */
export const AnimaticValueShelf$inboundSchema: z.ZodType<
  AnimaticValueShelf,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(AnimaticValueItem$inboundSchema),
});
/** @internal */
export type AnimaticValueShelf$Outbound = {
  items: Array<AnimaticValueItem$Outbound>;
};

/** @internal */
export const AnimaticValueShelf$outboundSchema: z.ZodType<
  AnimaticValueShelf$Outbound,
  z.ZodTypeDef,
  AnimaticValueShelf
> = z.object({
  items: z.array(AnimaticValueItem$outboundSchema),
});

export function animaticValueShelfToJSON(
  animaticValueShelf: AnimaticValueShelf,
): string {
  return JSON.stringify(
    AnimaticValueShelf$outboundSchema.parse(animaticValueShelf),
  );
}
export function animaticValueShelfFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticValueShelf, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticValueShelf$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticValueShelf' from JSON`,
  );
}
